import { useQueryClient } from '@tanstack/react-query'
import { forceTransitOperationStatusV2 } from './http'
import { transitOperationCacheRoots } from '../keys'

function useForceTransitOperationStatus() {
  const queryClient = useQueryClient()

  const forceStatusForTransitOperation = async (transitOperationId: number | undefined) => {
    if (transitOperationId === null || transitOperationId === undefined) {
      throw new Error('Transit Operation ID cannot be null or undefined!')
    }

    await forceTransitOperationStatusV2(transitOperationId)
    transitOperationCacheRoots.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }))
  }

  return {
    forceStatusForTransitOperation,
  } as const
}

export default useForceTransitOperationStatus
